module.exports = __webpack_public_path__ + "static/img/company.83fdc400.png";